// @flow
export default function formatNumberWithCommas(value: any) {
  const formatResult = value.toString();
  const integerPart = formatResult.split('.')[0];
  const decimalPart = formatResult.split('.')[1] || '00';

  return (
    integerPart.replace(/(\d)(?=(\d{3})+$)/g, '$1,') +
    '.' +
    (decimalPart || '0')
  );
}
